import { render, staticRenderFns } from "./CompetencyGraph.vue?vue&type=template&id=b9cceab0&scoped=true&"
import script from "./CompetencyGraph.vue?vue&type=script&lang=js&"
export * from "./CompetencyGraph.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9cceab0",
  null
  
)

export default component.exports